import OverworldStateMachine from './state-machine/OverworldStateMachine.js';
import OverworldGUI from './ui/OverworldGUI.js';
import { imageStore, spriteStore } from './images.js';
import { audioManager } from './AudioManager.js';
import { moveSetManager } from './data/managers/MoveSetManager.js';
import { moveDataLoader } from './data/MoveDataLoader.js';
import { itemDataLoader } from './data/ItemDataLoader.js';
import { playerManager } from './entities/Player.js';
import { pokemonDataLoader } from './data/PokemonDataLoader.js';
import { locationDataLoader } from './data/LocationDataLoader.js';
import { updateKeyHighlights } from './setup.js';
import { FRAME_DURATION, GAME_VERSION } from './constants.js';
import { keys } from './setup.js';
import { pollGamepad } from './GamepadManager.js';

let OSM; // Module-private; use getOSM() for a consistent reference
let GUI; // Module-private; use getGUI() for a consistent reference
export const globalPokemonDataStore = {};
export const globalMoveDataStore = {};
export const globalItemDataStore = {};
export let pokedexCatalogData = null; // Store pokedex catalog data globally
export function setOSM(newOSM) {
    OSM = newOSM;
}

export function getOSM() {
    return OSM;
}

export function getGUI() {
    return GUI;
}

/**
 * Current battle state machine, or undefined when not in battle.
 * Use this instead of holding a reference so it stays consistent (e.g. after load).
 */
export function getBattleStateMachine() {
    return getOSM()?.battleStateMachine;
}

/**
 * Current battle GUI, or undefined when not in battle.
 * Use this instead of holding a reference so it stays consistent.
 */
export function getBattleGUI() {
    return getBattleStateMachine()?.battleGUI;
}

// Track keyboard states
let TD_A_1 = false;
let TD_S_1 = false;
let TD_D_1 = false;
let TD_W_1 = false;
let TD_L_1 = false;
let TD_K_1 = false;
let TD_P_1 = false;
let TD_E_1 = false;
let TD___1 = false;
let TD_ENTER_1 = false;
let TD_A_2 = false;
let TD_S_2 = false;
let TD_D_2 = false;
let TD_W_2 = false;
let TD_L_2 = false;
let TD_K_2 = false;
let TD_P_2 = false;
let TD_E_2 = false;
let TD___2 = false;
let TD_ENTER_2 = false;
export let KPI_A = false;
export let KPI_S = false;
export let KPI_D = false;
export let KPI_W = false;
export let KPI_L = false;
export let KPI_K = false;
export let KPI_P = false;
export let KPI_E = false;
export let KPI___ = false;
export let KPI_ENTER = false;

export let KPH_A = false;
export let KPH_S = false;
export let KPH_D = false;
export let KPH_W = false;
export let KPH_L = false;
export let KPH_K = false;
export let KPH_P = false;
export let KPH_E = false;
export let KPH___ = false;
export let KPH_ENTER = false;

export let KRI_A = false;
export let KRI_S = false;
export let KRI_D = false;
export let KRI_W = false;
export let KRI_L = false;
export let KRI_K = false;
export let KRI_P = false;
export let KRI_E = false;
export let KRI___ = false;
export let KRI_ENTER = false;

export const availableMapSources = [
    {
        identifier: 'player_house',
        mapType: 'town',
        needsFlash: false,
        source: 'assets/maps/player_house/player_house_2f.tmj',
        foregroundSources: ['maps/player_house/foregrounds/fg_0.png'],
        backgroundSources: ['maps/player_house/backgrounds/bg_0.png'],
        mapDimensions: { width: 40, height: 40 },
        availablePokemon: [],
        canBike: false,
    },
    // {
    //     identifier: 'battle_sandbox',
    //     mapType: 'town',
    //     needsFlash: false,
    //     source: 'assets/maps/battle_sandbox/battle_sandbox.tmj',
    //     foregroundSources: ['maps/battle_sandbox/foregrounds/fg_0.png'],
    //     backgroundSources: ['maps/battle_sandbox/backgrounds/bg_0.png'],
    //     mapDimensions: { width: 32, height: 32 },
    //     availablePokemon: [],
    // },
    {
        identifier: 'bramblecrest_npc_house',
        mapType: 'town',
        needsFlash: false,
        source: 'assets/maps/bramblecrest_npc_house/bramblecrest_npc_house.tmj',
        foregroundSources: [],
        backgroundSources: ['maps/bramblecrest_npc_house/backgrounds/bg_0.png'],
        mapDimensions: { width: 40, height: 40 },
        availablePokemon: [],
        canBike: false,
    },
    {
        identifier: 'rival_house',
        mapType: 'town',
        needsFlash: false,
        source: 'assets/maps/rival_house/rival_house.tmj',
        foregroundSources: ['maps/rival_house/foregrounds/fg_0.png'],
        backgroundSources: ['maps/rival_house/backgrounds/bg_0.png'],
        mapDimensions: { width: 40, height: 40 },
        availablePokemon: [],
        canBike: false,
    },
    {
        identifier: 'mistral_heights_npc_1_house',
        mapType: 'town',
        needsFlash: false,
        source: 'assets/maps/mistral_heights_npc_1_house/mistral_heights_npc_1_house.tmj',
        foregroundSources: ['maps/mistral_heights_npc_1_house/foregrounds/fg_0.png'],
        backgroundSources: ['maps/mistral_heights_npc_1_house/backgrounds/bg_0.png'],
        mapDimensions: { width: 40, height: 40 },
        availablePokemon: [],
        canBike: false,
    },
    {
        identifier: 'mistral_heights_npc_2_house',
        mapType: 'town',
        needsFlash: false,
        source: 'assets/maps/mistral_heights_npc_2_house/mistral_heights_npc_2_house.tmj',
        foregroundSources: ['maps/mistral_heights_npc_2_house/foregrounds/fg_0.png'],
        backgroundSources: ['maps/mistral_heights_npc_2_house/backgrounds/bg_0.png'],
        mapDimensions: { width: 40, height: 40 },
        availablePokemon: [],
        canBike: false,
    },
    {
        identifier: 'pokemon_lab',
        mapType: 'town',
        needsFlash: false,
        source: 'assets/maps/pokemon_lab/pokemon_lab.tmj',
        backgroundSources: ['maps/pokemon_lab/backgrounds/bg_0.png'],
        foregroundSources: ['maps/pokemon_lab/foregrounds/fg_0.png'],
        mapDimensions: { width: 40, height: 40 },
        availablePokemon: [],
        canBike: false,
    },
    {
        identifier: 'bramblecrest',
        mapType: 'town',
        needsFlash: false,
        encounterRate: 0.05,
        source: `assets/maps/bramblecrest/bramblecrestv5.tmj`,
        foregroundSources: [
            'maps/bramblecrest/foregrounds/new/fg_0.png',
            'maps/bramblecrest/foregrounds/new/fg_1.png',
            'maps/bramblecrest/foregrounds/new/fg_2.png',
        ],
        backgroundSources: [
            'maps/bramblecrest/backgrounds/new/bg_0.png',
            'maps/bramblecrest/backgrounds/new/bg_1.png',
            'maps/bramblecrest/backgrounds/new/bg_2.png',
        ],
        mapDimensions: { width: 160, height: 50 },
        availablePokemon: [
            { id: 1, chance: 1, minLevel: 5, maxLevel: 5 }, // Bulbasaur
            { id: 4, chance: 1, minLevel: 5, maxLevel: 5 }, // Charmander
            { id: 7, chance: 1, minLevel: 5, maxLevel: 5 }, // Squirtle
            { id: 285, chance: 5, minLevel: 2, maxLevel: 4 }, // Shroomish
            { id: 263, chance: 40, minLevel: 2, maxLevel: 4 }, // Zigzagoon
            { id: 265, chance: 40, minLevel: 2, maxLevel: 4 }, // Wurmple
            { id: 269, chance: 1, minLevel: 10, maxLevel: 10 }, //Dustox
            { id: 267, chance: 1, minLevel: 10, maxLevel: 10 }, // Beautifly
        ],
        canBike: true,
    },
    // {
    //     identifier: 'mt_vine',
    //     mapType: 'route',
    //     needsFlash: false,
    //     encounterRate: 0.08,
    //     source: `assets/maps/mt_vine/mt_vine.tmj`,
    //     foregroundSources: [
    //         'maps/mt_vine/foregrounds/fg_0.png',
    //         'maps/mt_vine/foregrounds/fg_1.png',
    //         'maps/mt_vine/foregrounds/fg_2.png',
    //     ],
    //     backgroundSources: [
    //         'maps/mt_vine/backgrounds/bg_0.png',
    //         'maps/mt_vine/backgrounds/bg_1.png',
    //         'maps/mt_vine/backgrounds/bg_2.png',
    //     ],
    //     mapDimensions: { width: 46, height: 72 },
    //     availablePokemon: [
    //         { id: 216, chance: 9, minLevel: 5, maxLevel: 7 }, // Teddiursa
    //         { id: 217, chance: 1, minLevel: 25, maxLevel: 35 }, // Ursaring
    //         { id: 231, chance: 14, minLevel: 5, maxLevel: 7 }, // Phanpy
    //         { id: 232, chance: 1, minLevel: 25, maxLevel: 35 }, // Donphan
    //         { id: 234, chance: 15, minLevel: 6, maxLevel: 8 }, // Stantler
    //         { id: 263, chance: 20, minLevel: 5, maxLevel: 7 }, // Zigzagoon
    //         { id: 333, chance: 20, minLevel: 5, maxLevel: 7 }, // Swablu
    //         { id: 265, chance: 10, minLevel: 4, maxLevel: 6 }, // Wurmple
    //         { id: 266, chance: 3, minLevel: 7, maxLevel: 9 }, // Silcoon
    //         { id: 267, chance: 2, minLevel: 10, maxLevel: 10 }, // Beautifly
    //         { id: 268, chance: 3, minLevel: 7, maxLevel: 9 }, // Cascoon
    //         { id: 269, chance: 2, minLevel: 10, maxLevel: 10 }, //Dustox
    //     ],
    //     canBike: true,
    // },
    {
        identifier: 'vine_cave',
        needsFlash: true,
        mapType: 'cave',
        encounterRate: 0.02,
        source: 'assets/maps/vine_cave/vine_cave.tmj',
        foregroundSources: ['maps/vine_cave/foregrounds/fg_0.png'],
        backgroundSources: ['maps/vine_cave/backgrounds/bg_0.png'],
        mapDimensions: { width: 35, height: 32 },
        availablePokemon: [],
        canBike: true,
    },
    {
        identifier: 'test_town_pc',
        source: 'assets/maps/mistral_heights_pokemon_center_inside/pokemon_center_inside.tmj',
        backgroundSources: ['maps/mistral_heights_pokemon_center_inside/backgrounds/bg_0.png'],
        foregroundSources: ['maps/mistral_heights_pokemon_center_inside/foregrounds/fg_0.png'],
        mapDimensions: { width: 48, height: 48 },
        fixedTimeOfDay: 'day',
        availablePokemon: [],
        canBike: false,
    },
    {
        identifier: 'test_town_mart',
        source: 'assets/maps/mistral_heights_mart_inside/mart_inside.tmj',
        backgroundSources: ['maps/mistral_heights_mart_inside/backgrounds/bg_0.png'],
        foregroundSources: ['maps/mistral_heights_mart_inside/foregrounds/fg_0.png'],
        mapDimensions: { width: 48, height: 48 },
        availablePokemon: [],
        fixedTimeOfDay: 'day',
        canBike: false,
    },
];

export const availableMaps = {};
// Player spawn location
const initialMapIdentifier = 'player_house';
// const initialMapIdentifier = 'battle_sandbox';

// Function to load all maps
async function loadAllMaps(mapSources) {
    console.log('Loading maps...');
    const loadMapPromises = mapSources.map(async (mapSource) => {
        try {
            const loadedMap = await OverworldStateMachine.loadMap({
                identifier: mapSource.identifier,
                availablePokemon: mapSource.availablePokemon || [],
                mapDimensions: mapSource.mapDimensions,
                source: mapSource.source,
                backgroundSources: mapSource.backgroundSources,
                foregroundSources: mapSource.foregroundSources,
                encounterRate: mapSource.encounterRate,
                mapType: mapSource.mapType,
                needsFlash: mapSource.needsFlash ?? false,
                canBike: mapSource.canBike ?? true,
                fixedTimeOfDay: mapSource.fixedTimeOfDay,
            });
            availableMaps[mapSource.identifier] = loadedMap;
        } catch (error) {
            console.error(`Error loading map with identifier ${mapSource.identifier}:`, error);
        }
    });

    await Promise.all(loadMapPromises);
}

async function loadPokedexData(pokedexId = 1) {
    const STORAGE_KEY = 'pokedex_data';
    const API_BASE = import.meta.env.VITE_API_BASE || 'https://api.pkmng.orly.io/api';

    // Check if we should force refresh (skip localStorage check)
    const shouldRefresh = localStorage.getItem('pkmng_force_refresh') === 'true';

    // Check localStorage first - if data exists and we're not forcing refresh, use it and skip API
    if (!shouldRefresh) {
        try {
            const cachedData = localStorage.getItem(STORAGE_KEY);
            if (cachedData) {
                const pokedexData = JSON.parse(cachedData);
                // Try to find pokedex by identifier or numeric id
                pokedexCatalogData = pokedexData[pokedexId] || Object.values(pokedexData)[0] || null;
                console.log(`Loaded pokedex data from localStorage (cached)`);
                return pokedexData;
            }
        } catch (error) {
            console.error(`Error loading pokedex data from localStorage: ${error.message}`);
        }
    }

    // If not in localStorage, fetch all pokedexes from API
    try {
        updateLoadingText('Loading pokedex catalog...');
        const pokedexes = await fetch(`${API_BASE}/game/pokedexes`).then((res) => res.json());

        // Build pokedex_data object using identifier as keys
        const pokedexData = {};
        let targetIdentifier = null;

        for (const pokedex of pokedexes) {
            const identifier = pokedex.identifier;
            const id = pokedex.id;
            if (identifier && id) {
                try {
                    // Fetch using id, but store using identifier as key
                    const entries = await fetch(`${API_BASE}/game/pokedexes/${id}/entries`).then((res) =>
                        res.json()
                    );
                    pokedexData[identifier] = entries;
                    console.log(`Fetched entries for pokedex ${identifier} (id: ${id})`);

                    // If pokedexId matches this pokedex's id, remember its identifier
                    if (id === pokedexId || identifier === pokedexId) {
                        targetIdentifier = identifier;
                    }
                } catch (error) {
                    console.error(
                        `Error fetching entries for pokedex ${identifier} (id: ${id}): ${error.message}`
                    );
                }
            }
        }

        // Replace entire pokedex_data in localStorage
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(pokedexData));
            console.log(`Saved pokedex data to localStorage`);
        } catch (error) {
            console.error(`Error saving pokedex data to localStorage: ${error.message}`);
        }

        // Set the requested pokedex data globally
        // Use the target identifier if found, otherwise use the pokedexId directly, or fall back to first entry
        pokedexCatalogData =
            pokedexData[targetIdentifier || pokedexId] || Object.values(pokedexData)[0] || null;
        return pokedexData;
    } catch (error) {
        console.error(`Error fetching pokedex catalog from API: ${error.message}`);
        throw error;
    }
}

// ===============================
// AUTHENTICATION INTEGRATION
// ===============================

// Show auth error in the loading overlay
function showAuthError(message) {
    const overlay = document.getElementById('loadingOverlay');
    if (overlay) {
        overlay.innerHTML = `
      <div style="text-align: center; color: white; font-family: 'BattleFont', sans-serif;">
        <div style="color: #ff6b6b; font-size: 1.5em; margin-bottom: 16px;">${message}</div>
        <button onclick="location.reload()" style="
          padding: 12px 24px;
          background: rgb(25, 25, 25);
          color: white;
          border: none;
          border-radius: 8px;
          font-family: 'BattleFont', sans-serif;
          cursor: pointer;
          font-size: 16px;
        ">Try Again</button>
      </div>
    `;
    }
}

// Progress tracking system
let currentProgress = 0;

// Define loading steps with their weights (percentages)
// Total should add up to 100%
const LOADING_STEPS = {
    FETCHING_VERSION: 1,
    CHECKING_UPDATES: 1,
    REFRESHING_DATA: 1,
    LOADING_ASSETS: 6, // Images, sprites, audio
    POKEMON_DATA_API: 6,
    POKEMON_DATA_MEMORY: 3,
    LOCATION_DATA: 10,
    MOVE_DATA: 20,
    ITEM_DATA: 3,
    MOVESET_DATA: 40, // Learnset data (largest component)
    CREATING_PLAYER: 1,
    ADDING_ITEMS: 2,
    LOADING_MAPS: 2,
    POKEDEX_DATA: 1,
    FINALIZING: 1, // Final setup
};

/**
 * Update loading progress
 * @param {string} step - The loading step key from LOADING_STEPS
 * @param {string|null} [label=null] - Optional label to display
 */
function updateLoadingProgress(step, label = null) {
    const weight = LOADING_STEPS[step] || 0;
    currentProgress += weight;

    // Ensure progress doesn't exceed 100%
    currentProgress = Math.min(currentProgress, 100);

    const progressBar = document.getElementById('loadingProgressBar');
    const progressPercentage = document.getElementById('loadingProgressPercentage');
    const progressLabel = document.getElementById('loadingProgressLabel');

    if (progressBar) {
        progressBar.style.width = `${currentProgress}%`;
    }

    if (progressPercentage) {
        progressPercentage.textContent = `${Math.round(currentProgress)}%`;
    }

    if (progressLabel && label) {
        progressLabel.textContent = label;
    }
}

/**
 * Animate progress quickly for localStorage loads (instant loads)
 * @param {string} step - The loading step key from LOADING_STEPS
 * @param {string|null} [label=null] - Optional label to display
 * @param {number} [duration=300] - Animation duration in milliseconds
 */
async function animateQuickProgress(step, label = null, duration = 300) {
    const weight = LOADING_STEPS[step] || 0;
    const startProgress = currentProgress;
    const endProgress = Math.min(currentProgress + weight, 100);

    const progressBar = document.getElementById('loadingProgressBar');
    const progressPercentage = document.getElementById('loadingProgressPercentage');
    const progressLabel = document.getElementById('loadingProgressLabel');

    if (progressLabel && label) {
        progressLabel.textContent = label;
    }

    // Animate progress bar smoothly
    const startTime = Date.now();
    const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress =
            progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2; // Ease-in-out

        const current = startProgress + (endProgress - startProgress) * easedProgress;

        if (progressBar) {
            progressBar.style.width = `${current}%`;
        }

        if (progressPercentage) {
            progressPercentage.textContent = `${Math.round(current)}%`;
        }

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            currentProgress = endProgress;
        }
    };

    animate();

    // Wait for animation to complete
    await new Promise((resolve) => setTimeout(resolve, duration));
}

// Export for use in other modules
export { updateLoadingProgress, animateQuickProgress };

// Reset progress (for retries)
function resetLoadingProgress() {
    currentProgress = 0;
    const progressBar = document.getElementById('loadingProgressBar');
    const progressPercentage = document.getElementById('loadingProgressPercentage');
    const progressLabel = document.getElementById('loadingProgressLabel');

    if (progressBar) {
        progressBar.style.width = '0%';
    }
    if (progressPercentage) {
        progressPercentage.textContent = '0%';
    }
    if (progressLabel) {
        progressLabel.textContent = 'Loading...';
    }
}

// Update loading overlay text (kept for backward compatibility, but now uses progress bar)
function updateLoadingText(text) {
    const progressLabel = document.getElementById('loadingProgressLabel');
    if (progressLabel) {
        progressLabel.textContent = text;
    }
}

// Hide loading overlay
function hideLoadingOverlay() {
    const loadingOverlay = document.getElementById('loadingOverlay');
    if (loadingOverlay) {
        loadingOverlay.classList.add('fade-out');
        setTimeout(() => {
            loadingOverlay.style.display = 'none';
        }, 600);
    }
}

// Store fetched game version
let fetchedGameVersion = null;

async function fetchGameVersion() {
    try {
        const API_BASE = import.meta.env.VITE_API_BASE || 'https://api.pkmng.orly.io/api';
        const response = await fetch(`${API_BASE}/deployment-version/`);

        if (!response.ok) {
            throw new Error(`Failed to fetch deployment version: ${response.status}`);
        }

        const data = await response.json();

        // Get the pkmng service deployment info
        if (data.pkmng) {
            // Prefer branch_number (PR number) if available, format as "0.{branch_number}"
            // Otherwise use first 8 characters of deployment_hash
            if (data.pkmng.branch_number !== null && data.pkmng.branch_number !== undefined) {
                fetchedGameVersion = `0.${data.pkmng.branch_number}`;
            } else if (data.pkmng.deployment_hash) {
                // Use the first 8 characters of the deployment hash as the version
                fetchedGameVersion = `0.${data.pkmng.deployment_hash.substring(0, 8)}`;
            } else {
                throw new Error('No version information available in API response');
            }
            return fetchedGameVersion;
        }

        // Fallback to constant if API doesn't have pkmng deployment info
        console.warn('pkmng deployment version not found in API response, using fallback');
        fetchedGameVersion = GAME_VERSION;
        return fetchedGameVersion;
    } catch (error) {
        console.error('Failed to fetch game version from API:', error);
        // Fallback to constant on error
        fetchedGameVersion = GAME_VERSION;
        return fetchedGameVersion;
    }
}

function loadGameVersion() {
    const versionElement = document.getElementById('versionText');
    const versionToDisplay = fetchedGameVersion || GAME_VERSION;
    if (versionElement) {
        versionElement.textContent = versionToDisplay;
    }
}

// Main game initialization
async function initializeGame() {
    try {
        resetLoadingProgress();
        updateLoadingProgress('FETCHING_VERSION', 'Fetching game version...');

        // Fetch game version from API first
        const version = await fetchGameVersion();

        // Update GameSaveManager with the fetched version
        const { gameSaveManager } = await import('./entities/GameSaveManager.js');
        gameSaveManager.setVersion(version);

        updateLoadingProgress('CHECKING_UPDATES', 'Checking for data updates...');

        // Check if data needs to be refreshed
        const { checkDataVersion, updateLocalDataVersion, clearCachedData, setShouldRefreshFlag } =
            await import('./data/DataVersionChecker.js');
        const shouldRefresh = await checkDataVersion();

        if (shouldRefresh) {
            updateLoadingProgress('REFRESHING_DATA', 'Refreshing game data...');
            // Clear cached data to force fresh fetch
            clearCachedData();
            // Set flags to force refresh from API
            pokemonDataLoader.overwriteLocalStorage = true;
            locationDataLoader.overwriteLocalStorage = true;
            moveDataLoader.alwaysFetchFromAPI = true;
            itemDataLoader.alwaysFetchFromAPI = true;
            moveSetManager.alwaysFetchFromAPI = true;
            setShouldRefreshFlag(true);
        }

        updateLoadingProgress('LOADING_ASSETS', 'Loading game assets...');
        loadGameVersion();
        await imageStore.loadAllImages();
        await spriteStore.loadEssentialSprites();
        await audioManager.loadAllAudios();

        // await pokemonDataLoader.loadPokemonData();
        await pokemonDataLoader.loadPokemonDataFromAPI();

        updateLoadingProgress('POKEMON_DATA_MEMORY', 'Processing Pokemon data...');
        await pokemonDataLoader.loadPokemonDataIntoMemory();

        await locationDataLoader.loadLocationDataFromAPI();

        await moveDataLoader.loadMoveData();

        await itemDataLoader.loadItemData();

        await moveSetManager.loadAllMoveSets();

        updateLoadingProgress('CREATING_PLAYER', 'Creating player...');
        const player = await playerManager.loadPlayerData();

        updateLoadingProgress('LOADING_MAPS', 'Loading maps...');
        await loadAllMaps(availableMapSources);

        updateLoadingProgress('POKEDEX_DATA', 'Loading Pokedex data...');
        await loadPokedexData(1);

        // Update local data version after successful load of all data
        if (shouldRefresh) {
            await updateLocalDataVersion();
            setShouldRefreshFlag(false); // Clear the refresh flag
        }

        updateLoadingProgress('FINALIZING', 'Finalizing...');

        if (availableMaps[initialMapIdentifier]) {
            const initialMap = availableMaps[initialMapIdentifier];

            // Instantiate OSM and GUI with the initial map
            OSM = new OverworldStateMachine({ player: player, map: initialMap });
            GUI = new OverworldGUI({ stateMachine: OSM });

            // Ensure progress is at 100%
            currentProgress = 100;
            updateLoadingProgress('', 'Ready!');

            // Small delay to show 100% before hiding
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Start the animation loop
            hideLoadingOverlay();
            animateOverworldV2();

            console.info('Game loaded successfully.');
        } else {
            throw new Error(`Initial map with identifier "${initialMapIdentifier}" could not be loaded.`);
        }
    } catch (error) {
        console.error('Error during game initialization:', error);
        showAuthError('Failed to load game. Please refresh and try again.');
    }
}

// Authentication check and game startup
async function startGameWithAuth() {
    try {
        resetLoadingProgress();
        updateLoadingProgress('', 'Checking authentication...');

        // Check if gameAuth is available
        if (!window.gameAuth) {
            throw new Error('Authentication system not loaded');
        }

        // Initialize authentication
        await window.gameAuth.initialize();

        // Get user info
        const user = window.gameAuth.getCurrentUser();
        console.log(`🎮 Welcome to the game, ${user?.username ?? 'Dev'}!`);

        // Start the game
        await initializeGame();

    } catch (error) {
        console.error('❌ Authentication failed:', error);
        showAuthError('Authentication failed. Please refresh and try again.');
    }
}

// Start the authentication flow when this module loads
startGameWithAuth();

// ===============================
// ANIMATION LOOP
// ===============================

let lastFrameTime = 0;
let frameCount = 0;

setInterval(() => {
    const gui = getGUI();
    if (gui) {
        gui.currentFPS = frameCount * 2;
        gui.performanceSnapshot = gui.performance;
    }
    const osm = getOSM();
    if (osm) {
        osm.performanceSnapshot = osm.performance;
    }
    frameCount = 0;
}, 500);

setInterval(() => {
    const osm = getOSM();
    if (osm) {
        if (osm.userInputWithinLastMinute) {
            osm.userInputWithinLastMinute = false;
            osm.totalTimePlayed += 1;
        }
    }
}, 1000 * 60);

export function animateOverworldV2(currentTime) {
    updateKeyHighlights();
    window.requestAnimationFrame(animateOverworldV2);

    const deltaTime = currentTime - lastFrameTime;

    // Only update if enough time has passed for the target frame duration
    if (deltaTime < FRAME_DURATION) {
        return;
    }

    pollGamepad();

    frameCount += 1;
    // Update key states
    TD_A_1 = keys.a.pressed || keys.A.pressed;
    TD_S_1 = keys.s.pressed || keys.S.pressed;
    TD_D_1 = keys.d.pressed || keys.D.pressed;
    TD_W_1 = keys.w.pressed || keys.W.pressed;
    TD_L_1 = keys.l.pressed || keys.L.pressed;
    TD_K_1 = keys.k.pressed || keys.K.pressed;
    TD_P_1 = keys.p.pressed || keys.P.pressed;
    TD_E_1 = keys.e.pressed || keys.E.pressed;
    TD___1 = keys.space.pressed;
    TD_ENTER_1 = keys.enter.pressed;

    // Compute "key press initiated" states
    KPI_A = TD_A_1 ^ TD_A_2 && TD_A_1;
    KPI_S = TD_S_1 ^ TD_S_2 && TD_S_1;
    KPI_D = TD_D_1 ^ TD_D_2 && TD_D_1;
    KPI_W = TD_W_1 ^ TD_W_2 && TD_W_1;
    KPI_L = TD_L_1 ^ TD_L_2 && TD_L_1;
    KPI_K = TD_K_1 ^ TD_K_2 && TD_K_1;
    KPI_P = TD_P_1 ^ TD_P_2 && TD_P_1;
    KPI_E = TD_E_1 ^ TD_E_2 && TD_E_1;
    KPI___ = TD___1 ^ TD___2 && TD___1;
    KPI_ENTER = TD_ENTER_1 ^ TD_ENTER_2 && TD_ENTER_1;

    // Key Press and Hold - true when key was pressed last frame and is still pressed
    KPH_A = TD_A_1 && TD_A_2;
    KPH_S = TD_S_1 && TD_S_2;
    KPH_D = TD_D_1 && TD_D_2;
    KPH_W = TD_W_1 && TD_W_2;
    KPH_L = TD_L_1 && TD_L_2;
    KPH_K = TD_K_1 && TD_K_2;
    KPH_P = TD_P_1 && TD_P_2;
    KPH_E = TD_E_1 && TD_E_2;
    KPH___ = TD___1 && TD___2;
    KPH_ENTER = TD_ENTER_1 && TD_ENTER_2;

    // Key Release Instant - true when key was pressed last frame but is not pressed now
    KRI_A = TD_A_2 && !TD_A_1;
    KRI_S = TD_S_2 && !TD_S_1;
    KRI_D = TD_D_2 && !TD_D_1;
    KRI_W = TD_W_2 && !TD_W_1;
    KRI_L = TD_L_2 && !TD_L_1;
    KRI_K = TD_K_2 && !TD_K_1;
    KRI_P = TD_P_2 && !TD_P_1;
    KRI_E = TD_E_2 && !TD_E_1;
    KRI___ = TD___2 && !TD___1;
    KRI_ENTER = TD_ENTER_2 && !TD_ENTER_1;

    const osm = getOSM();
    const gui = getGUI();
    const trackInputs = (stateMachine) => {
        if (KPI_A || KPI_S || KPI_D || KPI_W || KPI_L || KPI_K || KPI_ENTER || KPI___) {
            stateMachine.userInputWithinLastMinute = true;
            // Update last activity time for auto-save idle detection
            stateMachine.lastPlayerActivityTime = Date.now();
        }
    };

    // Update state machine and GUI if initialized
    if (osm) {
        osm.update();
        // Don't draw overworld when in battle – battle loop draws BattleGUI instead
        if (!osm.isInBattle() && gui) {
            gui.update();
        }
        trackInputs(osm);
    }

    // Store current key states for comparison in the next frame
    TD_A_2 = TD_A_1;
    TD_S_2 = TD_S_1;
    TD_D_2 = TD_D_1;
    TD_W_2 = TD_W_1;
    TD_L_2 = TD_L_1;
    TD_K_2 = TD_K_1;
    TD_P_2 = TD_P_1;
    TD_E_2 = TD_E_1;
    TD___2 = TD___1;
    TD_ENTER_2 = TD_ENTER_1;

    lastFrameTime = currentTime;
}
